const efileTypesReducer = (state = [{code: "", description: ""}], action) => {
  switch (action.type) {
    case 'LANDSHARK_EFILE_TYPES':
      return action.results;
    default:
      break;
  }
  return state;
}

export default efileTypesReducer;